import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useSidebar } from "../../contexts/SidebarContext";
export const HamburgerButton = () => {
    const { toggleSidebar } = useSidebar();
    return (_jsx(IconButton, Object.assign({ onClick: toggleSidebar, "data-testid": "hamburger-button", sx: {
            display: { xs: "flex", md: "none" },
            color: "#092D4C",
        } }, { children: _jsx(MenuIcon, {}) })));
};
